import { render, staticRenderFns } from "./d-upvotes-modal.vue?vue&type=template&id=abdd2ae4&scoped=true&"
import script from "./d-upvotes-modal.vue?vue&type=script&lang=js&"
export * from "./d-upvotes-modal.vue?vue&type=script&lang=js&"
import style0 from "./d-upvotes-modal.vue?vue&type=style&index=0&id=abdd2ae4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abdd2ae4",
  null
  
)

export default component.exports